import { ReactNode } from "react";
import { useNavigate } from "react-router";
import { Button } from "../Button";
import FirebaseKey from "../FirebaseKey/FirebaseKey";

interface PageLayoutProps {
  children: ReactNode;
  title?: string;
}

const PageLayout = ({ children, title }: PageLayoutProps) => {
  const navigate = useNavigate();

  const handleClose = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      navigate("/");
    }
  };

  const handleBack = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      navigate("/");
    }
  };

  return (
    <div className="min-h-screen w-full bg-white flex flex-col">
      {/* Header */}
      <header className="sticky top-0 z-[100] py-[22px] px-7">
        <div className="flex justify-between items-center max-w-full">
          <div className="w-8 h-8"></div>
          <h1
            className="text-lg font-semibold text-black m-0 flex-1 text-center flex items-center justify-center"
            aria-label="KAZAN KAZAN"
          >
            <svg
              width="129"
              height="13"
              viewBox="0 0 129 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.0918 8.79785L2.00391 5.87109H2.4082L7.40918 0H10.002L5.05371 5.72168L3.82324 6.78516L2.0918 8.79785ZM0 12.6826V0H2.25879V12.6826H0ZM7.61133 12.6826L3.4541 6.81152L5.0625 5.2998L10.3799 12.6826H7.61133ZM11.4521 12.6826L15.9521 0H17.833V2.35547H17.1562L13.8252 12.6826H11.4521ZM13.7197 9.4043L14.3174 7.65527H20.127L20.7246 9.4043H13.7197ZM20.6367 12.6826L17.3057 2.35547V0H18.5098L23.0098 12.6826H20.6367ZM24.8027 12.6826V11.1709L31.4824 2.05664V1.90723H24.9873V0H34.2773V1.50293L27.624 10.626V10.7754H34.4443V12.6826H24.8027ZM36.2549 12.6826L40.7549 0H42.6357V2.35547H41.959L38.6279 12.6826H36.2549ZM38.5225 9.4043L39.1201 7.65527H44.9297L45.5273 9.4043H38.5225ZM45.4395 12.6826L42.1084 2.35547V0H43.3125L47.8125 12.6826H45.4395ZM49.957 12.6826V0H51.9258L58.7549 9.58887L57.1641 8.74512H58.2891V0H60.4775V12.6826H58.5176L51.6797 3.08496L53.2705 3.92871H52.1455V12.6826H49.957ZM70.418 8.79785L70.3301 5.87109H70.7344L75.7354 0H78.3281L73.3799 5.72168L72.1494 6.78516L70.418 8.79785ZM68.3262 12.6826V0H70.585V12.6826H68.3262ZM75.9375 12.6826L71.7803 6.81152L73.3887 5.2998L78.7061 12.6826H75.9375ZM79.7783 12.6826L84.2783 0H86.1592V2.35547H85.4824L82.1514 12.6826H79.7783ZM82.0459 9.4043L82.6436 7.65527H88.4531L89.0508 9.4043H82.0459ZM88.9629 12.6826L85.6318 2.35547V0H86.8359L91.3359 12.6826H88.9629ZM93.1289 12.6826V11.1709L99.8086 2.05664V1.90723H93.3135V0H102.604V1.50293L95.9502 10.626V10.7754H102.771V12.6826H93.1289ZM104.581 12.6826L109.081 0H110.962V2.35547H110.285L106.954 12.6826H104.581ZM106.849 9.4043L107.446 7.65527H113.256L113.854 9.4043H106.849ZM113.766 12.6826L110.435 2.35547V0H111.639L116.139 12.6826H113.766ZM118.283 12.6826V0H120.252L127.081 9.58887L125.49 8.74512H126.615V0H128.804V12.6826H126.844L120.006 3.08496L121.597 3.92871H120.472V12.6826H118.283Z"
                fill="black"
              />
            </svg>
          </h1>
          <button
            className="bg-transparent border-none cursor-pointer p-1 flex items-center justify-center text-black transition-opacity hover:opacity-70 active:opacity-50 w-8 h-8"
            onClick={handleClose}
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.45767 8.4585L23.5426 23.5434M23.5423 8.4585L8.45736 23.5434"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </header>

      <main className="flex-1 flex flex-col px-6">
        {/* Back Button */}
        <div className="py-2 flex justify-start">
          <Button
            variant="gray"
            size={2}
            onClick={handleBack}
            className="rounded-full bg-white shadow-[0_4px_48px_0_rgba(0,0,0,0.08)]"
          >
            <FirebaseKey firebaseKey="button_back" />
          </Button>
        </div>

        <div className="flex-1 pb-8">{children}</div>
      </main>
    </div>
  );
};

export default PageLayout;
